<template>
  <div id="app">
   
    <router-view />
  </div>
</template>
<script>
import topBar from './pages/topbar.vue'
export default {
  name: 'app',
  components:{
    topBar
  },
  data() {
    return {
    };
  },
  computed: {

  },
  mounted() {
    
  },
  created(){
  },
  activated(){
    
    
  },
  methods:{
    
    
  }
};
</script>

<style lang="less">
body {
  background-color: #f5f7fb;
  font-family: Microsoft YaHei, Arial, Helvetica, sans-serif !important;
}

#app {
  font-style: normal;
  font-weight: 400;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

</style>
